import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'
import { appendAudioFile } from './audioUpload'

/**
 * Create a new notification sound upload.
 * @param audioBlob {Blob|File}
 * @returns {Promise<import('axios').AxiosResponse<string>>}
 */
const Create = audioBlob => {
  const formData = new FormData()
  appendAudioFile(formData, audioBlob)

  return mainHTTPClient.post(
    MAIN_HTTP_API_ENDPOINTS.AUDIOS,
    formData
  )
}

/**
 * Replace an existing notification sound upload.
 * @param audioPath {string}
 * @param audioBlob {Blob|File}
 * @returns {Promise<import('axios').AxiosResponse<string>>}
 */
const Update = (audioPath, audioBlob) => {
  const formData = new FormData()
  formData.append('audioPath', audioPath)
  appendAudioFile(formData, audioBlob)

  return mainHTTPClient.put(
    MAIN_HTTP_API_ENDPOINTS.AUDIOS,
    formData
  )
}

const AudioService = {
  Create,
  Update
}

export default AudioService
